import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo",
  "use": "logo-usage",
  "viewBox": "0 0 55 54",
  "content": "<symbol viewBox=\"0 0 55 54\" xmlns=\"http://www.w3.org/2000/svg\" id=\"logo\"><rect x=\"7.5\" y=\"7\" width=\"40\" height=\"40\" rx=\"6\" /><circle cx=\"19.3\" cy=\"20.2867\" r=\"5.8\" stroke=\"white\" stroke-width=\"2\" /><rect x=\"30.1001\" y=\"14.7867\" width=\"11\" height=\"11\" rx=\"2.58492\" stroke=\"white\" stroke-width=\"2\" /><rect x=\"13.5\" y=\"30.5133\" width=\"28\" height=\"9\" rx=\"2.58492\" stroke=\"white\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol